import React, { Component } from "react";

import "../earnings-list/ListPage.css";

export default class EntityListPageContainer extends Component {
  render() {
    const { children } = this.props;
    return <div className="nc-list-page-container">{children}</div>;
  }
}
